import {
  APP_CONTAINER_NODE_CLASSNAME,
  APP_ROOT_NODE_CLASSNAME,
  POPUP_NODE_CLASSNAME,
} from "shared/constants/common.constants";

import { APP_FONTS_REGISTER_STYLESHEET_HREF, APP_FONTS_STYLESHEET_HREF, APP_STYLESHEET_HREF } from "./url.utils";

export class AppDOM {
  private static _shadowRootNode: ShadowRoot;
  private static _appContainer: HTMLDivElement;

  public static get shadowRootNode() {
    return AppDOM._shadowRootNode;
  }

  public static get appContainer() {
    return AppDOM._appContainer;
  }

  public static setShadowRootNode(shadowRootNode: ShadowRoot) {
    AppDOM._shadowRootNode = shadowRootNode;
  }

  public static setAppContainer(appContainer: HTMLDivElement) {
    AppDOM._appContainer = appContainer;
  }

  public static querySelector<T extends HTMLElement>(selector: string): T | null {
    return this.shadowRootNode?.querySelector(selector) ?? document.querySelector(selector);
  }
}

declare global {
  interface Window {
    grecaptcha?:
      | {
          enterprise: {
            ready: (callback: () => void) => void;
            execute: (siteKey: string, options: { action: string }) => Promise<string>;
          };
        }
      | undefined;
  }
}

export const googleRecaptcha = new (class {
  private scriptKey = "6Le26QwrAAAAAKtAk6ew1D3fFygLdCzrBWg2WxKo";

  createScriptElement(): HTMLScriptElement {
    const script = document.createElement("script");
    script.src = `https://www.google.com/recaptcha/enterprise.js?render=${this.scriptKey}`;
    script.async = true;
    script.defer = true;

    return script;
  }

  ready(callback: () => void): void {
    try {
      window?.grecaptcha?.enterprise?.ready(async () => {
        callback();
      });
    } catch (_) {
      callback();
    }
  }

  async getToken(): Promise<string | undefined> {
    return await window?.grecaptcha?.enterprise?.execute(this.scriptKey, {
      action: "TRACKING",
    });
  }
})();

export type InitialNodesReturnType = {
  appContainer: HTMLDivElement;
  appRoot: HTMLDivElement;
  modalNode: HTMLDivElement;
  appStylesheetNode: HTMLLinkElement;
  fontsRegisterStylesheetNode: HTMLLinkElement;
  fontsStylesheetNode: HTMLLinkElement;
};

export const createInitialNodes = (): InitialNodesReturnType => {
  const appContainer = document.createElement("div");
  appContainer.className = APP_CONTAINER_NODE_CLASSNAME;

  const appRoot = document.createElement("div");
  appRoot.className = APP_ROOT_NODE_CLASSNAME;

  const modalNode = document.createElement("div");
  modalNode.className = POPUP_NODE_CLASSNAME;

  const appStylesheetNode = document.createElement("link");
  appStylesheetNode.type = "text/css";
  appStylesheetNode.rel = "stylesheet";
  appStylesheetNode.href = APP_STYLESHEET_HREF;

  const fontsRegisterStylesheetNode = document.createElement("link");
  fontsRegisterStylesheetNode.type = "text/css";
  fontsRegisterStylesheetNode.rel = "stylesheet";
  fontsRegisterStylesheetNode.href = APP_FONTS_REGISTER_STYLESHEET_HREF;

  const fontsStylesheetNode = document.createElement("link");
  fontsStylesheetNode.type = "text/css";
  fontsStylesheetNode.rel = "stylesheet";
  fontsStylesheetNode.href = APP_FONTS_STYLESHEET_HREF;

  return {
    appContainer,
    appRoot,
    modalNode,
    appStylesheetNode,
    fontsRegisterStylesheetNode,
    fontsStylesheetNode,
  };
};
